var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"store-empty-conteiner"},[_c('div',{staticClass:"img-box",class:[_vm.type]}),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }